/**
 * Coarse-grained status of a visitor-management submission plus whether it
 * can currently be cancelled, mirroring the `SubmissionDetails` GraphQL
 * type. Derived server-side (and, during the VisitorManagementM2Refactor
 * rollout, client-side as a fallback) from the aggregate pass records
 * sharing a submissionId.
 */
export enum SubmissionStatus {
  Invalid = 'INVALID',
  Cancelled = 'CANCELLED',
}

export interface SubmissionDetails {
  status: SubmissionStatus;
  isCancellable: boolean;
}
